import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useSelector} from 'react-redux';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import ConfirmModal from '../project/ConfirmModal';
import OrganisationListView from './OrganisationListView';
import interventionService from '../../services/intervention/InterventionService';
import {status} from '../../utils/constant';
import {TYPES} from './utils/utils';

function OrganisationListContainer(props) {
  const organisation = useSelector(state => state.organisation);
  const [organisationToDelete, setOrganisationToDelete] = React.useState(null);
  const [hasInterventionInProject, setHasInterventionInProject] = React.useState(null);

  const handleMenuBtnClick = organisationId => {
    setHasInterventionInProject(null);
    const searchParams = [
      props.type === TYPES.CLIENT ? organisationId : organisation.organisationId,
      props.type === TYPES.CLIENT ? organisation.organisationId : organisationId,
      status.ACCEPTED
    ];

    interventionService.searchByClientAndSubcontractor(...searchParams)
      .then(response => {
        setHasInterventionInProject(!isEmpty(response.interventions));
      });
  };

  const handleDeleteOrganisation = () => {
    if (hasInterventionInProject || hasInterventionInProject === null) {
      return;
    }

    props.onDeleteRelationship(organisationToDelete.relationshipId);
    setOrganisationToDelete(null);
  };

  return (
    <>
      <OrganisationListView
        type={props.type}
        organisations={props.organisations}
        loading={props.loading}
        onMenuBtnClick={handleMenuBtnClick}
        onDeleteOrganisation={value => setOrganisationToDelete(value)}
        hasInterventionInProject={hasInterventionInProject}
        onPageChange={props.onPageChange}
        pageNumber={props.pageNumber}
        pageSize={props.pageSize}
        totalCount={props.totalCount}
        dossierCountry={props.dossierCountry}
      />
      {Boolean(organisationToDelete) &&
        <ConfirmModal
          onClose={() => setOrganisationToDelete(null)}
          isOpen={Boolean(organisationToDelete)}
          content={<Translate
            value="organisation.delete.confirmDeleteOrganisation.content"
            organisationName={organisationToDelete.fullName}
          />}
          warning={<Translate value={`organisation.delete.confirmDeleteOrganisation.warning.${props.type}`}/>}
          onConfirm={handleDeleteOrganisation}
        />
      }
    </>
  );
}

OrganisationListContainer.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPES)).isRequired,
  organisations: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onDeleteRelationship: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  dossierCountry: PropTypes.string
};

export default OrganisationListContainer;
